import * as types from '../reducer';

const logout = () => async dispatch => {
  dispatch({ type: types.LOGIN_START });
  localStorage.removeItem('session-token');
  localStorage.removeItem('session-usrid');
  dispatch({ type: types.LOGIN_CLEAR });
}

export default logout;